import styled from 'styled-components';
import { Typ20 } from 'dc/Typ';
import Swi01 from 'dc/Swi01';

export const SwitchWrapper = styled.div`
  width: 100%;
  display: flex;
  padding-top: 8px;
`;

export const SmallText = styled(Typ20)`
  color: #546e7a;
  text-align: left;
  flex-grow: 0;
  margin-right: 24px;
`;

export const ToggleWrapper = styled.div`
  width: 34px;
`;

export const ToggleSwitch = styled(Swi01)`
  & > div {
    ${props =>
      props.checked ? 'background-color: rgba(0, 166, 182, 0.4);' : null};
  }
  & > div:before {
    ${props => (props.checked ? 'background-color: #00a6b6;' : null)};
  }
`;
